
import { defineComponent } from "vue";

type ComponentData = {
  show: boolean;
  hours: number;
  minutes: number;
  validation_message?: string;
  clock: boolean[][];
};
const default_clock: boolean[][] = [];

for (let i = -1; i < 24; i++) {
  default_clock[i] = [];
  for (let j = 0; j < 60; j++) default_clock[i][j] = i !== -1;
}

export default defineComponent({
  name: "TimePicker",
  data(): ComponentData {
    const clock = (this.$props.custom_clock as boolean[][]) || default_clock;
    clock[-1] = default_clock[-1];

    return {
      show: false,
      validation_message: undefined,
      clock,
      hours:
        this.modelValue !== undefined &&
        this.modelValue !== null &&
        this.modelValue >= 0
          ? (this.modelValue / 60) >> 0
          : -1,
      minutes:
        this.modelValue !== undefined &&
        this.modelValue !== null &&
        this.modelValue >= 0
          ? this.modelValue % 60
          : -1,
    };
  },
  props: {
    modelValue: Number,
    name: String,
    label: String,
    validation: Object,
    required: Boolean,
    disabled: Boolean,
    custom_clock: Array,
  },
  emits: ["update:modelValue", "updateValidation"],
  methods: {
    toggle() {
      this.show = !this.show && !this.disabled;
      if (this.show == false) this.validate();
      if (this.show == false && this.minutes < 0) {
        this.hours = -1;
        this.minutes = -1;
        this.$emit("update:modelValue", -1);
      }
    },
    setHours(hours: number) {
      this.hours = hours;
      this.minutes = -1;
      this.validate();
    },
    setMinutes(minutes: number) {
      this.minutes = minutes;
      this.show = false;
      this.$emit("update:modelValue", this.hours * 60 + this.minutes);
      this.validate();
    },
    validate() {
      if (this.required && this.hours < 0 && this.minutes < 0)
        this.validation_message = "Campo obrigatória";
      else this.validation_message = undefined;
      this.$emit("updateValidation", this.name, !this.validation_message);
    },
  },
  watch: {
    modelValue(t) {
      if (t === null || t === undefined || t < 0) {
        this.hours = -1;
        this.minutes = -1;
      } else {
        this.hours = (t / 60) >> 0;
        this.minutes = t % 60;
      }
      this.validate();
    },
    validation(value) {
      this.validation_message = value.message;
    },
    disabled(d) {
      if (d) {
        this.hours = -1;
        this.minutes = -1;
      }
    },
  },
});
